export default "__VITE_ASSET__12ce27ee__"